module.exports = __webpack_public_path__ + "img/lucky-draw-center.3851f9b.png";